export default __webpack_public_path__ + "static/media/cosmonaute-2-new.20004125.png";